module.exports = __webpack_public_path__ + "img/maridaje_rose.3859730e.png";